import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
//import { useSelector } from 'react-redux'
import { Modal, Dropdown } from 'react-bootstrap'
import Select from 'react-select'

import ByDay from './ByDay'
import ByShift from './ByShift'
import { httpOk, GET } from 'helpers/api'
import { formatDate } from 'helpers/helpers'

function Index() {
	const { t } = useTranslation()

	//const reduxAccount = useSelector(state => state.account)

	const [poses, setPoses] = useState([])
	const [cashboxes, setCashboxes] = useState([])
	const [shifts, setShifts] = useState([])
	const [shiftId, setShiftId] = useState(null)
	const [modal, setModal] = useState({
		'cashbox': false,
		'shift': false,
	})
	const [activeComponent, setActiveComponent] = useState('ByDay')
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterData, setFilterData] = useState({
		//'pos_id': reduxAccount.pos_id,
	})

	async function searchWithFilter() {
		setModal({ ...modal, 'shift': false })
		setShiftId(filterData.shift_id)
		setActiveComponent('ByShift')
		setDropdownIsOpen(false)
	}

	async function toggleModal(bool = false) {
		if (bool) {
			const responseCashbox = await GET('/cashbox', {}, { 'loader': true })
			if (httpOk(responseCashbox)) {

				if (responseCashbox.data.length === 1) {
					const responseShifts = await GET(`/cashbox/shift/${responseCashbox.data[0]['id']}`, {}, { 'loader': true })
					if (httpOk(responseShifts)) {
						setShifts(responseShifts.data.data)
						setModal({
							...modal,
							'cashbox': false,
							'shift': true,
						})
						return
					}
				}

				if (responseCashbox.data.length > 1) {
					setCashboxes(responseCashbox.data)
					setModal({
						...modal,
						'cashbox': true,
						'shift': false,
					})
					return
				}
			}
		}

		setModal({
			...modal,
			'cashbox': false,
			'shift': false,
		})
	}

	async function handleSelectPos(option) {
		setFilterData({ ...filterData, 'pos_id': option ? option.id : null })

		if (!option.id) return

		const responseCashbox = await GET(`/cashbox?pos_id=${option.id}`, {}, { 'loader': true })
		if (httpOk(responseCashbox)) {

			if (responseCashbox.data.length === 1) {
				const responseShifts = await GET(`/cashbox/shift/${responseCashbox.data[0]['id']}`, {}, { 'loader': true })
				if (httpOk(responseShifts)) {
					setShifts(responseShifts.data.data)
					return
				}
			}

			if (responseCashbox.data.length > 1) {
				setCashboxes(responseCashbox.data)
				return
			}
		}
	}

	async function handleSelectCashbox(option) {
		setFilterData({ ...filterData, 'cashbox_id': option ? option.id : null })

		if (!option.id) return

		const responseShifts = await GET(`/cashbox/shift/${option.id}`, {}, { 'loader': true })
		if (httpOk(responseShifts)) {
			setShifts(responseShifts.data.data)
			return
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function getPoses() {
		const response = await GET('/helper/poses')
		if (httpOk(response)) setPoses(response.data)
	}

	useEffect(() => {
		getPoses()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="d-flex justify-content-between flex-wrap mb-3">
				<div className="d-flex flex-wrap gap-2">
					<div>
						<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
							<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
								{t('filter')}
							</Dropdown.Toggle>

							<Dropdown.Menu className="dropdown-filter">
								<div className="row">
									<div className="form-group col-md-6">
										<label>{t('pos')}</label>
										<Select
											options={poses}
											value={poses.find(option => option.id === filterData.pos_id) || ''}
											onChange={(option) => handleSelectPos(option)}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(option) => option.name}
											getOptionValue={(option) => option.id}
										/>
									</div>
								</div>
								<div className="row">
									<div className="form-group col-md-6">
										<label>{t('cashboxes')}</label>
										<Select
											options={cashboxes}
											value={cashboxes.find(option => option.id === filterData.cashbox_id) || ''}
											onChange={(option) => handleSelectCashbox(option)}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(option) => option.name}
											getOptionValue={(option) => option.id}
										/>
									</div>
									<div className="form-group col-md-6">
										<label>{t('shifts')}</label>
										<Select
											options={shifts}
											value={shifts.find(option => option.id === filterData.shift_id) || ''}
											onChange={(option) => setFilterData({ ...filterData, 'shift_id': option ? option.id : null })}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(option) => option.id}
											getOptionValue={(option) => option.id}
										/>
										<i className="uil-ellipsis-h react-select-dots"
											onClick={() => setModal({
												...modal,
												'cashbox': false,
												'shift': true,
											})} />
									</div>
								</div>
								<div className="row mt-3">
									<div className="col-md-12">
										<div className="d-flex justify-content-end gap-2">
											<button className="btn btn-secondary"
												onClick={() => setDropdownIsOpen(false)}>
												{t('cancel')}
											</button>
											<button className="btn btn-primary"
												onClick={() => searchWithFilter()}>
												{t('apply')}
											</button>
										</div>
									</div>
								</div>
							</Dropdown.Menu>
						</Dropdown>
					</div>
				</div>
			</div>

			{!activeComponent &&
				<div className="d-flex justify-content-center gap-3 h-100">
					<div className="dashboard-card" style={{ 'backgroundColor': '#ECE7DF' }}>
						<div className="dashboard-card-main">
							<div className="d-flex justify-content-between mb-5">
								<div className="d-flex flex-column gap-3">
									<span style={{ 'fontSize': '12px' }}>Дашборд</span>
									<b style={{ 'fontSize': '20px' }}>По смене</b>
								</div>
								<picture>
									<img src="https://cdn.skillbox.pro/landgen/blocks/start-screen/157013/thumbnail_lg/f8024488-dff9-4525-a64e-0b5988142d37-2x.webp"
										alt="data"
										width={100} />
								</picture>
							</div>
							<div>* Продажи, надбавки, скидки, кол-во продуктов</div>
							<div>* Зал, собой, доставка</div>
							<div>* Чеки, средний чек, глубина чека, гости, удаление</div>
							<div>* Наличные, терминал, сумма</div>
							<div>* Типы оплат</div>
							<div>* Расходы</div>
							<div>* Доставка детализированно</div>
							<div>* Чеки по часам, час пик</div>
							<div>* Сумма чеков по часам</div>
							<div>* Меню</div>
							<div>* Продукты</div>
							<div>* Кассиры</div>
							<div>* Официанты</div>
						</div>
					</div>
				</div>
			}

			{activeComponent === 'ByDay' &&
				<ByDay></ByDay>
			}

			{activeComponent === 'ByShift' &&
				<ByShift shift_id={shiftId}></ByShift>
			}

			{/* MODAL SHIFTS */}
			<Modal show={modal.shift} animation={false}
				centered size="lg" onHide={() => toggleModal()}>
				<Modal.Header closeButton>
					<Modal.Title>{t('shifts')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '70px' }}>ID</th>
									<th>{t('cashier')}</th>
									<th className="text-center td-ellipsis">{t('open_date')}</th>
									<th className="text-center td-ellipsis">{t('close_date')}</th>
								</tr>
							</thead>
							<tbody>
								{shifts?.map((item, index) => (
									<tr key={index} className="bg-on-hover"
										onClick={() => {
											setModal({ ...modal, 'shift': false })
											setFilterData({ ...filterData, 'shift_id': item.id })
										}}>
										<td>{item.id}</td>
										<td className="td-ellipsis">{item.cashier_name}</td>
										<td className="text-center">{formatDate(item.opened_at, 'dd.MM.yy HH:mm')}</td>
										<td className="text-center">{formatDate(item.closed_at, 'dd.MM.yy HH:mm')}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL SHIFTS */}
		</>
	)
}

export default Index
